import React from 'react';

import PropTypes from 'prop-types';

import Confirm from 'components/Confirm';
import Message from 'components/Message';
import { bem } from 'helpers/class-name';

import flyoutMessages from '../shared/SkuOrderFlyout.messages';
import messages from './SkuOutOfStockConfirmModal.messages';
import './SkuOutOfStockConfirmModal.scss';

export const SKU_OUT_OF_STOCK_CONFIRM_MODAL_NAME = 'SkuOutOfStockConfirmModal';

const { block, element } = bem('sku-out-of-stock-confirm-modal');

const SkuOutOfStockConfirmModal = ({
  removedItemName,
  isOnlyItemInOrder,
  integrationName,
  onConfirm,
  onCancel,
  onRequestClose,
}) => {
  const removesItem = Boolean(removedItemName);
  const cancelsOrder = !removesItem || isOnlyItemInOrder;
  const removeItemBody = isOnlyItemInOrder ? messages.removeOnlyItemBody : messages.removeItemBody;

  return (
    <Confirm
      className={block()}
      title={
        removesItem ? (
          <Message message={messages.removeItemTitle} values={{ itemName: removedItemName }} />
        ) : (
          <Message message={messages.title} />
        )
      }
      hasCloseButton
      onRequestClose={onRequestClose}
      onCancel={onCancel}
      cancelNode={<Message message={messages.goBack} />}
      acceptNode={<Message message={cancelsOrder ? flyoutMessages.cancelOrder : messages.removeItem} />}
      acceptStyle={cancelsOrder ? 'danger-solid' : 'primary'}
      onConfirm={onConfirm}>
      <Message message={removesItem ? removeItemBody : messages.body} />
      {integrationName && (
        <p className={element('integration-hint')}>
          <Message message={messages.integrationHint} values={{ integrationName }} />
        </p>
      )}
    </Confirm>
  );
};

SkuOutOfStockConfirmModal.propTypes = {
  removedItemName: PropTypes.string,
  isOnlyItemInOrder: PropTypes.bool,
  integrationName: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onRequestClose: PropTypes.func,
};

export default SkuOutOfStockConfirmModal;
